import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoadingModule } from '@coin/shared/core/data-access';
import { FeatureFlagDirective } from '@coin/shared/core/feature-directives';
import {
  FxConversionPipe,
  FxRatePipe,
  IndividualMultiplierPipe,
  IsoToCountryPipe
} from '@coin/shared/core/feature-pipes';
import {
  DropdownSearchDirective,
  V2ButtonComponent,
  V2CheckboxComponent,
  V2DateInputComponent,
  V2DateRangeInputComponent,
  V2DialogModule,
  V2DropdownComponent,
  V2DualPillComponent,
  V2NumberInputComponent,
  V2TextAreaComponent,
  V2TextInputComponent,
  V2TurbineComponent
} from '@coin/shared/core/ui-storybook';
import {
  ControlDisabledDirective,
  EllipsisTooltipDirective,
  TemplateWithValueDirective,
  TwoDecimalPlacesDirective
} from '@coin/shared/core/util-directives';
import {
  EmployeeNamePipe,
  EnumToTextPipe,
  FormatUnknownValuePipe,
  MgmtGroupTranslationPipe,
  PureFunctionPipe,
  ThousandsSeparatorPipe
} from '@coin/shared/core/util-pipes';
import { TranslateModule } from '@ngx-translate/core';
import { ArcElement, Chart, PieController } from 'chart.js';
import { SimplebarAngularModule } from 'simplebar-angular';
import { AnimIconComponent } from './components/anim-icon/anim-icon.component';
import { ColorPickerComponent } from './components/color-picker/color-picker.component';
import { CommentComponent } from './components/comment/comment.component';
import { CommentsComponent } from './components/comments/comments.component';
import { ConfirmChecklistComponent } from './components/confirm-checklist/confirm-checklist.component';
import { DividerComponent } from './components/divider/divider.component';
import { IconTextCardComponent } from './components/icon-text-card/icon-text-card.component';
import { InfoTooltipComponent } from './components/info-tooltip/info-tooltip.component';
import { ListHeaderComponent } from './components/list-header/list-header.component';
import { ListItemComponent } from './components/list-item/list-item.component';
import { ListViewFilterTagComponent } from './components/list-view-filter-tag/list-view-filter-tag.component';
import { NoBackendScreenComponent } from './components/no-backend-screen/no-backend-screen.component';
import { RequestSummaryComponent } from './components/request-summary/request-summary.component';
import { SimpleLangSwitchComponent } from './components/simple-lang-switch/simple-lang-switch.component';
import { InputOverlayComponent } from './components/input-overlay/input-overlay.component';
import { TopicItemComponent } from './components/topic-item/topic-item.component';
import { TruncatedTextComponent } from './components/truncated-text/truncated-text.component';

@NgModule({
  declarations: [
    CommentComponent,
    CommentsComponent,
    ConfirmChecklistComponent,
    TopicItemComponent,
    NoBackendScreenComponent,
    SimpleLangSwitchComponent,
    AnimIconComponent,
    InputOverlayComponent,
    InfoTooltipComponent,
    DividerComponent,
    RequestSummaryComponent,
    ListViewFilterTagComponent,
    TruncatedTextComponent,
    IconTextCardComponent,
    ListHeaderComponent,
    ListItemComponent,
    ColorPickerComponent
  ],
  imports: [
    CommonModule,
    SimplebarAngularModule,
    FormsModule,
    DragDropModule,
    MatIconModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatTooltipModule,
    MatCheckboxModule,
    TranslateModule.forChild(),
    MatOptionModule,
    MatDatepickerModule,
    MatProgressBarModule,
    OverlayModule,
    MatTabsModule,
    MatBadgeModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatButtonModule,
    PureFunctionPipe,
    V2DialogModule,
    ControlDisabledDirective,
    V2DateInputComponent,
    V2DateRangeInputComponent,
    MatRadioModule,
    FormatUnknownValuePipe,
    EnumToTextPipe,
    IsoToCountryPipe,
    EmployeeNamePipe,
    TwoDecimalPlacesDirective,
    FeatureFlagDirective,
    LoadingModule,
    V2DualPillComponent,
    V2CheckboxComponent,
    V2ButtonComponent,
    V2TextAreaComponent,
    V2TextInputComponent,
    EllipsisTooltipDirective,
    V2DropdownComponent,
    TemplateWithValueDirective,
    DropdownSearchDirective,
    V2TurbineComponent,
    V2NumberInputComponent
  ],
  exports: [
    CommentComponent,
    CommentsComponent,
    ConfirmChecklistComponent,
    TopicItemComponent,
    NoBackendScreenComponent,
    SimpleLangSwitchComponent,
    AnimIconComponent,
    InputOverlayComponent,
    InfoTooltipComponent,
    DividerComponent,
    ListViewFilterTagComponent,
    TruncatedTextComponent,
    IconTextCardComponent,
    ListHeaderComponent,
    ListItemComponent,
    ColorPickerComponent
  ],
  providers: [
    FxRatePipe,
    FxConversionPipe,
    MgmtGroupTranslationPipe,
    EnumToTextPipe,
    DecimalPipe,
    ThousandsSeparatorPipe,
    IndividualMultiplierPipe
  ]
})
export class LegacyComponentsModule {
  constructor() {
    Chart.register(PieController, ArcElement);
  }
}
